// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Check: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7">
            <path
                fill="currentcolor"
                d="M3.69319076,6.86253779 L8.86820256,1.46499381 C9.04393248,1.28168998 9.04393248,0.984515052 8.86820256,0.801229128 L8.2318189,0.137464443 C8.05608898,-0.0458214811 7.77114799,-0.0458214811 7.59541807,0.137464443 L3.37499893,4.53935245 L1.40458193,2.4842118 C1.22885201,2.30090797 0.943911022,2.30090797 0.768181103,2.4842118 L0.131797439,3.14797648 C-0.0439324798,3.33128031 -0.0439324798,3.62845524 0.131797439,3.81174117 L3.0568071,6.86251989 C3.23251985,7.04582372 3.51744367,7.04582372 3.69319076,6.86253779 Z"
            />
        </svg>
    );
};

export default React.memo(Check);
